import { render, staticRenderFns } from "./AddEmployeeWindow.vue?vue&type=template&id=13a40eb4"
import script from "./AddEmployeeWindow.vue?vue&type=script&lang=js"
export * from "./AddEmployeeWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports